import React, { useEffect, useRef, useState } from 'react';
import imageTesta from '../assets/trattamenti/testa-collo.jpg';
import imageSpalle from '../assets/trattamenti/spalla.jpg';
import imageGinocchio from '../assets/trattamenti/ginocchio.jpg';
import imageAnca from '../assets/trattamenti/anca.jpg';
import imagePiede from '../assets/trattamenti/Piede-caviglia.jpg';
import imageSchiena from '../assets/trattamenti/schiena.jpg';
import reviewsBackground from '../assets/recensioni_mcare.webp';
import ContactForm from '../components/contactForm/ContactForm';
import { useIntersectionObserver } from '../components/Observer';
import { Helmet } from "react-helmet";
import HumanBody from '../components/3dModel/HumanBody';
import { useNavigate } from 'react-router-dom';
import TecnologieImg from '../assets/tecnologie/the-procedure-of-myo.jpg'
import ContactModal from '../components/ContactModal';
import professionisti from '../assets/trattamenti/fisioterapia.jpg';
import mCareSede from '../assets/azienda/sede-mcare.png';
import player from '../assets/Servizi/player-reversed.webp';
import section2 from '../assets/Section 2.webp';
import logoUniversita from '../assets/logo/logoUniversita.png';
import { FaLocationDot } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import GridBox from '../components/GridBox';
import AnimatedTextWord from '../components/AnimatedTextWord';
import check from '../assets/icon/check.png';
import thunder from '../assets/icon/thunder.png';
import lens from '../assets/icon/lens.png';
import boost from '../assets/icon/boost.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import Hero from '../components/Hero';
import Minimal from '../components/Minimal';
import SwiperImage from '../components/SwiperImage';
import Reviews from '../components/Reviews';
import MComeVideo from '../components/MComeVideo';
import Dropdown from '../components/Dropdown';


const textsFirstSection = ["Ricerca", "Tempestività", "Performance", "Tecnologia"];
const flags = [
  {
    img: check,
    title: 'VALIDAZIONE ACCADEMICA.',
    subtitle: 'Metodo basato sulle più moderne evidenze scientifiche'
  },
  {
    img: thunder,
    title: 'TEMPESTIVITÀ ASSOLUTA.',
    subtitle: 'Presa in carico e piano d’azione entro 24/48 ore dall’infortunio.'
  },
  {
    img: lens,
    title: 'ANALISI BIOMECCANICA.',
    subtitle: 'Quantifichiamo ogni progresso attraverso dati oggettivi.'
  },
  {
    img: boost,
    title: 'RIENTRO ALLA PERFORMANCE.',
    subtitle: 'Non ci fermiamo alla fine del dolore: ti riportiamo in campo più forte di prima.'
  }
]


const trattamenti = [
  {
    img: imageTesta,
    path: '/testa-collo/',
    title: 'Testa/Collo',
    description: 'Dolore cervicale, ernie cervicali, post intervento chirurgico, terapia post colpo di frusta, cefalee, quadri vertiginosi, problematiche temporo-mandibolari (ATM).'
  },
  {
    img: imageSpalle,
    path: '/spalla/',
    title: 'Spalle',
    description: 'Tendinopatie, lussazioni, lesioni della cuffia dei rotatori, spalla congelata.'
  },
  {
    img: imageGinocchio,
    path: '/ginocchio/',
    title: 'Ginocchio',
    description: 'Lesioni legamentose, sindrome femoro-rotulea, tendinopatie.'
  },
  {
    img: imageAnca,
    path: '/anca-bacino/',
    title: 'Anca/Bacino',
    description: "Impingement femoro-acetabolare, tendinopatie, fratture, protesi dell'anca."
  },
  {
    img: imagePiede,
    path: '/caviglia-piede/',
    title: 'Caviglia e Piede',
    description: 'Distorsioni, fascite plantare, tendinopatie, lesioni osteocondrali.'
  },
  {
    img: imageSchiena,
    path: '/schiena/',
    title: 'Schiena',
    description: 'Lombalgia, ernia del disco, stenosi, spondilolistesi.'
  },
];

function HomePage() {
  const refPaolo = useRef(null);
  const refLuca = useRef(null);
  const refMartin = useRef(null);
  const [contactModal, setContactModal] = useState(false);
  const navigate = useNavigate();

  var ogImage = 'https://mcarefisio.it/static/media/logo2.47585272f37641121cdd.png';

  function goToPage(pageName) {
    navigate(pageName)
  }

  const options = {
    root: null,
    threshold: 0.5,
    rootMargin: "-95px"
  };

  useIntersectionObserver(refPaolo, options);
  useIntersectionObserver(refLuca, options);
  useIntersectionObserver(refMartin, options);

  const handleClickForm = () => {
      const element = document.querySelector('#formContatti');
      element.scrollIntoView({ behavior: 'smooth' });
  };

  const closeContactModal = () => {
    setContactModal(false);
  };

  return (
    <>

      <Hero handleClickForm={handleClickForm} />

      {/* SEZ. Università */}
      <div className='relative md:h-screen h-[1150px] overflow-hidden'>
        <img src={section2} alt="background section" className='h-full w-full object-cover bg-black opacity-60' />
        <div className='absolute inset-0 flex space-x-10'>
          
          <div className='flex flex-col h-full justify-center gap-16 w-full xl:w-2/3 px-10 lg:ml-32'>
            <div className='flex flex-col text-start gap-10'>
              <h2 className='text-white text-3xl md:text-4xl font-bold uppercase panoragraf-light' data-aos="fade-up" data-aos-duration="1000">Il recupero è scienza applicata</h2>
              <p className='text-white text-xl' data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">MCare nasce con un obiettivo preciso:  trasformare il recupero fisico in un percorso rapido, scientifico e multidisciplinare.</p>
            </div>
            <div className='flex flex-row gap-4 items-baseline flex-wrap' data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
              <p className='text-white text-xl text-start'>Un metodo scientifico costruito su: </p>
              <AnimatedTextWord texts={textsFirstSection} />
            </div>

            <div className='border-t border-white/50 w-full md:block hidden'/>

            {/* MOBILE: swiper */}
            <div className='md:hidden block'>
              <Swiper
                  slidesPerView={1}
                  spaceBetween={20}
                  autoplay={{
                      delay: 4000,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                  }}
                  modules={[Autoplay]}
                  className="w-full h-full">
                  {flags.map((flag, index) => (
                    <SwiperSlide key={index} className="overflow-hidden bg-[#00000099] p-4 rounded-lg gap-6"
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.5rem' }}>
                      <img src={flag.img} alt={flag.title} className='w-16 h-16' />
                      <p className='text-white text-base font-semibold uppercase'>{flag.title}</p>
                      <p className='text-white text-base uppercase text-center'>{flag.subtitle}</p>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>

            <div className='flex flex-col md:flex-row items-center gap-4'>
              <img src={logoUniversita} alt="logo università di verona" className='w-20 h-20' data-aos="fade-in" data-aos-duration="1000"/>
              <p className='text-white text-xs tracking-normal md:text-base uppercase text-center md:text-start' data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">centro universitario affiliato all'università degli studi di verona</p>
            </div>
          </div>

    

          <div className='flex-col justify-center gap-8 md:flex hidden'>
            {flags.map((flag, index) => (
              <div key={index} className="flex flex-row items-center gap-4 bg-[#00000099] w-full rounded-l-xl p-3 text-white">
                <img src={flag.img} alt={flag.title} className='w-16 shrink-0'/>
                <div>
                  <p className="font-semibold text-start w-full">{flag.title}</p>
                  <p className="text-start w-full">{flag.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <MComeVideo />
      
      <GridBox handleClickForm={handleClickForm}/>

      {/* SEZ TRATTAMENTI MOBILE */}
      <div className="grid grid-cols-4 gap-2 pb-20 bg-black pt-16" data-aos="fade-up" data-aos-duration="1000">
        <div className="col-span-4 text-center">
          <p className='font-semibold text-4xl my-10 panoragraf-light text-mcare'>Trattamenti personalizzati</p>
        </div>
        <div className="col-span-4 flex justify-center items-center">
          <p className="text-white text-center text text-xl px-5 xl:px-60"><strong>MCARE</strong> non è solo un centro di riabilitazione, ma un partner affidabile nel percorso di recupero e <em className='font-bold'>miglioramento della qualità di vita.</em></p>
        </div>
      </div>
      {/* sezioni trattamenti (accordion) */}
      <div className="flex flex-col gap-4 pb-10 px-0 md:px-40 lg:px-[30%] xl:px-0 2xl:px-32 xl:hidden">
        {trattamenti.map((item) => (
          <Dropdown
            key={item.path}
            img={item.img}
            alt={item.title}
            title={item.title}
            description={item.description}
            onDetails={() => goToPage(item.path)}
          />
        ))}
      </div>

      {/* SEZ TRATTAMENTI DESKTOP */}
      <div className='hidden xl:block'>
        <HumanBody prenota={handleClickForm} />
      </div>

      {/* SEZ. TECNOLOGIE */}
      <Minimal 
      title="Tecnologie Sport-Oriented" 
      image={TecnologieImg}
      alt
      imageMobileHidden={true}
      buttonText="scopri di più"
      sideSection="right"
      containerWidth="md:w-4/5 w-full"
      extraClass="space-y-6"
      content={
        <div className="text-xl" data-aos="fade-up" data-aos-duration="1000">
            <p className="text-balance lg:text-wrap">
                Presso il nostro centro di fisioterapia, abbracciamo l'innovazione
                utilizzando le più recenti tecnologie per garantire ai nostri
                pazienti esperienze di riabilitazione avanzate e personalizzate.
            </p>
        </div>
      }/>


      {/* SEZ PROFESSIONISTI */}
      <Minimal 
      title="I nostri professionisti" 
      image={professionisti} 
      alt
      imageMobileHidden={false}
      buttonText="scopri di più"
      sideSection="right"
      containerWidth="md:w-4/5 w-full"
      extraClass="space-y-6"
      content={
        <div className="text-xl text-white" data-aos="fade-up" data-aos-duration="1000">
            <p className="text-balance lg:text-wrap">
            Scopri il nostro team di professionisti pronto a seguirti nel tuo percorso di riabilitazione.<br/>
            Un team multidisciplinare composto da fisioterapisti specializzati in:
            </p>
            <ul className='mt-4 list-disc list-inside'>
              <li>Fisioterapia dello sport</li>
              <li>Ortopedia</li>
              <li>Preparazione Atletica</li>
              <li>Mental Coaching</li>
            </ul>
        </div>
      }/>

      {/* PSICOLOGIA DELLO SPORT */}
      <Minimal 
      title="Psicologia dello sport" 
      image={player} 
      alt
      imageMobileHidden={true}
      buttonText="scopri di più"
      sideSection="left"
      containerWidth="md:w-4/5 w-full"
      extraClass="space-y-6"
      content={
        <div className="text-xl" data-aos="fade-up" data-aos-duration="1000">
            <p className="text-balance lg:text-wrap">
              Supporto psicologico personalizzato per affrontare sfide emotive, motivazionali e mentali durante la carriera sportiva.
            </p>
            <ul className="mt-4 list-disc list-inside">
              <li>Colloqui individuali</li>
              <li>Mental Training post infortunio</li>
              <li>Assessment psicologico</li>
              <li>Tecniche di rilassamento e gestione dello stress</li>
            </ul>
        </div>
      }/>

      {/* TESTIMONIANZE */}
      <div className="py-16 h-screen relative flex items-center justify-center">
        <img src={reviewsBackground} alt="Testimonianze" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <Reviews />
      </div>

      {/* SEDI */}
      <Minimal 
      title="Dove ci trovi" 
      image={mCareSede}
      alt
      imageMobileHidden={false}
      sideSection={false}
      containerWidth="w-full"
      extraClass="space-y-20"
      content={
        <div className='grid md:grid-cols-2 grid-cols-1 place-content-center md:gap-24 gap-16 mx-4 md:mx-0'>
          <div className='flex flex-col items-center gap-10'>
              <FaLocationDot size={40} color="white" />
              <Link to="https://maps.app.goo.gl/wqGkMEmPocxQ7DjXA" target="_blank" className='text-white underline-animate text-xl skip-ink-auto'>Via Enrico Fermi 13/A, 37135, Verona</Link>
          </div>
          <div className='flex flex-col items-center gap-1'>
            <div className='flex flex-col items-center gap-10'>
              <FaLocationDot size={40} color="white" />
              <Link to="https://maps.app.goo.gl/xyPVjWf95XXx7KPA8" target="_blank" className='text-white underline-animate text-xl skip-ink-auto'>Via Toscana 13, 37060, Sona (VR)</Link>
            </div>
            <p className='uppercase text-sm text-white italic bg-mcare py-1 px-2 rounded-sm mt-2'>Prossima apertura Settembre 2026</p>
          </div>
        </div>
      }/>

      {/* sez. contatti */}
      <div className="grid grid-cols-4 gap-0" id='formContatti'>
        <div className="col-span-4 flex justify-center items-center py-32 bg-black">
          <div className="w-full absolute z-0" style={{ "height": "120%" }}></div>
          <div className='w-full lg:w-2/6 z-30 px-5'>
            <p className='text-center text-4xl font-semibold mb-6 text-mcare panoragraf-light'>Prenota una visita</p>
            <ContactForm
              LandingName='mcare'
              Name={true}
              NameClass='text-slate-50'
              NameText='Nome e Cognome:'
              NameRequired={true}
              Tel={true}
              TelClass='text-slate-50'
              TelText='Telefono:'
              TelRequired={true}
              Email={true}
              EmailClass='text-slate-50'
              EmailText='Email:'
              EmailRequired={true}
              ConsensoDati={true}
              ConsensoDatiRequired={true}
              ConsensoDatiText="Consenso dati"
              ConsensoDatiID={1}
              ConsensoDatiClass='text-slate-50'
              successText='Messaggio inviato con successo!'
              successLink='/'
              errorText='Si è verificato un errore, Riprova!'
              SendText='Invia'
              SendClass='progress-button-mcare w-full '
            />
          </div>
        </div>
      </div>
      <ContactModal isContactModal={contactModal} closeModal={closeContactModal} />
    </>
  )
}

export default HomePage;
